import { render, staticRenderFns } from "./MainMessageForm.vue?vue&type=template&id=6b99e97e&scoped=true&"
import script from "./MainMessageForm.vue?vue&type=script&lang=js&"
export * from "./MainMessageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b99e97e",
  null
  
)

export default component.exports